module.exports = __webpack_public_path__ + "img/currency-ruble.5272d200.svg";